// @flow

export default {
  toggleCurrentMethod: (item: string): { type: string, item: string } => ({
    type: 'TOGGLE_CURRENT_METHOD',
    item,
  }),
};
